import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import UpdateShippingDialogBox from './UpdateShippingDialogBox';

import NotFoundIcon from './../../assets/icons/not-found.png';
import { ArrowBackIcon, LinkIcon, CartIcon, ProfileIcon, ArrowDownIcon } from './Styles/Icons';
import {
	FlexRow,
	FlexColumn,
	TitleSection,
	TitleRow,
	Title,
	RootContainer,
	NotFound,
	Popover,
	PopoverItem,
	OrderDetailsHeader,
	OrderId,
	OrderDate,
	OrderStats,
	TableContainer,
	Table,
	TableHeader,
	TableBody,
	TableRow,
	TableColumn,
	TableHeaderRow,
	TableHeaderColumn,
	ProductImage,
	OrderDetailsContainer,
	PaymentDetailsContainer,
	PaymentSummaryContainer,
	BackButton,
	ProductName,
	ProductId,
	ProductPrice,
	ProductQuantity,
	ProductStatus,
	PaymentDetailsHeader,
	PaymentLine,
	PaymentKey,
	PaymentValue,
	PaymentConclusion,
	CustomerDetailsContainer,
	CustomerDetailsHeader,
	CustomerImage,
	CustomerDetailsValue,
	OrderTrackingLink,
	MoreDetails,
	CustomerSummaryContainer,
	CustomerDetailsLine,
	CustomerDetailsKey,
} from './Styles/OrderDetails.jsx';

import { getOrderDetails, updateOrderLines } from '../../actions/ordersActions.js';
import { formatCurrency, getOrderMonth } from '../../commons/utils';
import { ShippingOptions } from './Utils';

const PopoverIds = {
	SHIPPING: 'shipping-popover',
};
const DialogIds = {
	SHIPPING: 'shipping-dialog',
};

class OrderDetails extends Component {
	constructor(props) {
		super(props);
		this.state = {
			itemsCount: 0,
			unfulfilledItemsCount: 0,
			shippingPopoverItem: {},
			shippingPopoverAnchorEl: null,
			updateShippingDialogOpen: false,
		};
	}

	async componentDidMount() {
		await this.getOrderDetails();
	}

	handlePopoverClick = (popoverId, event) => {
		switch (popoverId) {
			case PopoverIds.SHIPPING:
				this.setState({ shippingPopoverAnchorEl: event.currentTarget });
				break;

			default:
				break;
		}
	};

	handlePopoverSelect = (popoverId, choice) => {
		switch (popoverId) {
			case PopoverIds.SHIPPING:
				if (choice === ShippingOptions.FULFILLED) {
					this.setState({ updateShippingDialogOpen: true });
				} else {
					this.updateShippingDetails(choice);
				}
				break;

			default:
				break;
		}
		this.handlePopoverClose(popoverId);
	};

	handlePopoverClose = (popoverId) => {
		switch (popoverId) {
			case PopoverIds.SHIPPING:
				this.setState({ shippingPopoverAnchorEl: null });
				break;

			default:
				break;
		}
	};

	handleDialogOnTrue = async (dialogId, value) => {
		switch (dialogId) {
			case DialogIds.SHIPPING:
				this.updateShippingDetails(ShippingOptions.FULFILLED, value);
				this.setState({ updateShippingDialogOpen: false });
				break;

			default:
				break;
		}
	};

	handleDialogOnFalse = (dialogId) => {
		switch (dialogId) {
			case DialogIds.SHIPPING:
				this.setState({ updateShippingDialogOpen: false });
				break;

			default:
				break;
		}
	};

	updateShippingDetails = async (status, trackingUrl = '') => {
		const { shippingPopoverItem } = this.state;
		const { selectedOrder } = this.props;
		let body = {};

		switch (status) {
			case ShippingOptions.FULFILLED:
				body = {
					status: ShippingOptions.FULFILLED,
					trackingUrl: trackingUrl,
					lineItemsList: [
						{
							orderLineId: shippingPopoverItem._id,
							shippedQty: shippingPopoverItem.qty,
						},
					],
				};
				break;

			case ShippingOptions.PROCESSING:
			case ShippingOptions.RETURNED:
			case ShippingOptions.CANCELLED:
				body = {
					status: status,
					lineItemsList: [
						{
							orderLineId: shippingPopoverItem._id,
							shippedQty: 0,
						},
					],
				};
				break;

			default:
				break;
		}

		await this.props.updateOrderLines(selectedOrder._id, body, () => {
			this.getOrderDetails();
		});
	};

	getOrderDetails = async () => {
		const { selectedOrder } = this.props;
		await this.props.getOrderDetails(selectedOrder._id);
		this.computeLineItems();
	};

	computeLineItems = () => {
		let { orderLines } = this.props;
		console.log('Here', orderLines);

		let fulfilled = 0;
		let totalItems = orderLines.length;

		orderLines.forEach((item) => {
			if (item.status === 'FULFILLED' || item.status === 'RETURNED') {
				fulfilled += 1;
			}
		});

		this.setState({
			unfulfilledItemsCount: totalItems - fulfilled,
			itemsCount: totalItems,
		});
	};

	render() {
		const { orderSummary = {}, orderLines = [], userDetails = {} } = this.props;
		const { itemsCount, unfulfilledItemsCount, updateShippingDialogOpen, shippingPopoverAnchorEl, shippingPopoverItem } = this.state;

		const formattedDate = orderSummary.order_date ? new Date(orderSummary.order_date) : null;
		const day = formattedDate ? formattedDate.getDate() : null;
		const month = formattedDate ? getOrderMonth(formattedDate.getMonth()) : null;
		const year = formattedDate ? formattedDate.getFullYear() : null;
		const hours = formattedDate ? formattedDate.getHours() : null;
		const minutes = formattedDate ? formattedDate.getMinutes() : null;

		return (
			<RootContainer>
				<Helmet>
					<title>Seller Portal | Order Details</title>
				</Helmet>

				<Popover
					id={PopoverIds.SHIPPING}
					open={Boolean(shippingPopoverAnchorEl)}
					anchorEl={shippingPopoverAnchorEl}
					onClose={() => this.handlePopoverClose(PopoverIds.SHIPPING)}
					anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
					transformOrigin={{ vertical: 'top', horizontal: 'right' }}
				>
					<PopoverItem
						disabled={[ShippingOptions.PENDING, ShippingOptions.PROCESSING, ShippingOptions.FULFILLED, ShippingOptions.RETURNED, ShippingOptions.CANCELLED].includes(
							shippingPopoverItem.status
						)}
						onClick={(e) => {
							this.handlePopoverSelect(PopoverIds.SHIPPING, ShippingOptions.PROCESSING);
						}}
					>
						Processing
					</PopoverItem>

					<PopoverItem
						disabled={[ShippingOptions.FULFILLED, ShippingOptions.RETURNED, ShippingOptions.CANCELLED].includes(shippingPopoverItem.status)}
						onClick={(e) => {
							this.handlePopoverSelect(PopoverIds.SHIPPING, ShippingOptions.FULFILLED);
						}}
					>
						Fulfill
					</PopoverItem>

					<PopoverItem
						disabled={![ShippingOptions.FULFILLED].includes(shippingPopoverItem.status)}
						onClick={(e) => {
							this.handlePopoverSelect(PopoverIds.SHIPPING, ShippingOptions.RETURNED);
						}}
					>
						Return
					</PopoverItem>

					<PopoverItem
						disabled={[ShippingOptions.FULFILLED, ShippingOptions.RETURNED, ShippingOptions.CANCELLED].includes(shippingPopoverItem.status)}
						onClick={(e) => {
							this.handlePopoverSelect(PopoverIds.SHIPPING, ShippingOptions.CANCELLED);
						}}
					>
						Cancel
					</PopoverItem>
				</Popover>

				<UpdateShippingDialogBox
					open={updateShippingDialogOpen}
					onTrue={(value) => this.handleDialogOnTrue(DialogIds.SHIPPING, value)}
					onFalse={() => this.handleDialogOnFalse(DialogIds.SHIPPING)}
				/>

				<TitleSection>
					<TitleRow responsive='1200px'>
						<FlexColumn style={{ display: 'inline' }}>
							<FlexRow style={{ gap: '2rem' }}>
								<Title>
									<BackButton
										outline
										onClick={() => this.props.onClose()}
									>
										<ArrowBackIcon />
									</BackButton>
									<span style={{ marginLeft: '1rem', fontSize: '16px', fontWeight: '500' }}>Back to all orders</span>
								</Title>
							</FlexRow>
						</FlexColumn>
					</TitleRow>
				</TitleSection>

				<FlexRow
					responsive={'900px'}
					style={{ padding: '0 2rem', margin: '0.5rem 0', gap: '2rem' }}
				>
					<FlexColumn style={{ flex: '9', gap: '2rem' }}>
						<FlexRow>
							<OrderDetailsContainer>
								<OrderDetailsHeader>
									<FlexRow>
										<OrderId>{orderSummary.order_id ? orderSummary.order_id : ''}</OrderId>
									</FlexRow>

									<FlexRow>
										<OrderDate>
											Ordered on {day} {month} {year} at {hours}:{minutes} PM
										</OrderDate>

										<OrderStats>{`Total: ${itemsCount ? itemsCount : 0} Unfulfilled: ${unfulfilledItemsCount ? unfulfilledItemsCount : 0}`}</OrderStats>
									</FlexRow>
								</OrderDetailsHeader>

								<TableContainer>
									<Table>
										<TableHeader>
											<TableHeaderRow>
												<TableHeaderColumn style={{ width: '55%' }}>Product Details</TableHeaderColumn>

												<TableHeaderColumn style={{ width: '15%', justifyContent: 'left' }}>Price</TableHeaderColumn>

												<TableHeaderColumn style={{ width: '15%', justifyContent: 'center' }}>Qty</TableHeaderColumn>

												<TableHeaderColumn style={{ width: '15%' }}>Status</TableHeaderColumn>
											</TableHeaderRow>
										</TableHeader>

										<TableBody>
											{orderLines ? (
												orderLines.map((item, index) => (
													<TableRow key={index}>
														<TableColumn style={{ width: '55%' }}>
															<FlexRow>
																<FlexColumn style={{ width: '4rem' }}>
																	<ProductImage src={item.image_url ? item.image_url : NotFoundIcon} />
																</FlexColumn>

																<FlexColumn>
																	<ProductName>{item.name}</ProductName>
																	<ProductId>{`Item ID: ${item.supplier_product_id}`}</ProductId>
																</FlexColumn>
															</FlexRow>
														</TableColumn>

														<TableColumn style={{ width: '15%', justifyContent: 'left' }}>
															<ProductPrice>{formatCurrency(item.price)}</ProductPrice>
														</TableColumn>

														<TableColumn style={{ width: '15%', justifyContent: 'center' }}>
															<ProductQuantity>{`${item.qty}`}</ProductQuantity>
														</TableColumn>

														<TableColumn style={{ width: '15%' }}>
															<ProductStatus
																onClick={(e) => {
																	this.setState({ shippingPopoverItem: item });
																	this.handlePopoverClick(PopoverIds.SHIPPING, e);
																}}
															>
																{`${item.status || ''}`}
																<ArrowDownIcon />
															</ProductStatus>
														</TableColumn>
													</TableRow>
												))
											) : (
												<TableRow key='not-found'>
													<TableColumn colSpan={'100%'}>
														<NotFound lines={["Couldn't find any items"]} />
													</TableColumn>
												</TableRow>
											)}
										</TableBody>
									</Table>
								</TableContainer>
							</OrderDetailsContainer>
						</FlexRow>

						<FlexRow>
							<PaymentDetailsContainer>
								<PaymentDetailsHeader>Payment Summary</PaymentDetailsHeader>

								<PaymentSummaryContainer>
									<PaymentLine>
										<PaymentKey> Subtotal </PaymentKey>
										<PaymentValue>{orderSummary.sub_total ? formatCurrency(orderSummary.sub_total) : 'NA'}</PaymentValue>
									</PaymentLine>

									<PaymentLine>
										<PaymentKey> Delivery Charges </PaymentKey>
										<PaymentValue>{orderSummary.shipping_charge ? formatCurrency(orderSummary.shipping_charge) : 'NA'}</PaymentValue>
									</PaymentLine>

									<PaymentLine>
										<PaymentKey> Taxes </PaymentKey>
										<PaymentValue>{orderSummary.tax ? formatCurrency(orderSummary.tax) : 'NA'}</PaymentValue>
									</PaymentLine>

									<PaymentConclusion>
										<PaymentKey> Paid by Customer </PaymentKey>
										<PaymentValue>{orderSummary.total ? formatCurrency(orderSummary.total) : 'NA'}</PaymentValue>
									</PaymentConclusion>
								</PaymentSummaryContainer>
							</PaymentDetailsContainer>
						</FlexRow>
					</FlexColumn>

					<FlexColumn style={{ flex: '3', maxWidth: 'auto', minWidth: '250px' }}>
						<FlexRow>
							<CustomerDetailsContainer>
								<CustomerDetailsHeader>Customer Details</CustomerDetailsHeader>

								<CustomerSummaryContainer>
									<CustomerImage>
										<ProfileIcon />
									</CustomerImage>

									<CustomerDetailsLine>
										<CustomerDetailsKey>{userDetails.name ? userDetails.name : ''}</CustomerDetailsKey>

										<CustomerDetailsValue>{userDetails.email ? userDetails.email : ''}</CustomerDetailsValue>

										<CustomerDetailsValue>{userDetails.phone ? userDetails.phone : ''}</CustomerDetailsValue>
									</CustomerDetailsLine>

									<CustomerDetailsLine>
										<CustomerDetailsKey>Shipping Address</CustomerDetailsKey>
										<CustomerDetailsValue>
											{orderSummary?.shipping_address
												? Array.isArray(orderSummary.shipping_address)
													? orderSummary.shipping_address.join(', ')
													: orderSummary.shipping_address
												: userDetails.address
												? `${userDetails?.address?.line1 || ''}, ${userDetails?.address?.city || ''}, ${userDetails?.address?.state || ''}, ${
														userDetails?.address?.zip_code || ''
												  }`
												: ''}
										</CustomerDetailsValue>
									</CustomerDetailsLine>

									{orderSummary?.ship_to ? (
										<CustomerDetailsLine>
											<CustomerDetailsKey>Ship To</CustomerDetailsKey>
											<CustomerDetailsValue>{orderSummary?.ship_to}</CustomerDetailsValue>
										</CustomerDetailsLine>
									) : null}

									{orderSummary.tracking_urls && orderSummary.tracking_urls.length ? (
										<CustomerDetailsLine>
											<CustomerDetailsKey>Tracking Links</CustomerDetailsKey>
											{orderSummary.tracking_urls.map((link, index) => (
												<OrderTrackingLink
													href={link}
													target='_blank'
												>
													<LinkIcon /> {`Link ${index + 1}`}
												</OrderTrackingLink>
											))}
										</CustomerDetailsLine>
									) : null}
								</CustomerSummaryContainer>

								<MoreDetails>
									<FlexColumn>
										<CustomerDetailsKey> More Details </CustomerDetailsKey>
										<CustomerDetailsValue>{`Placed ${userDetails.orderCountByUser || 0} orders in total`}</CustomerDetailsValue>
									</FlexColumn>
									<FlexColumn style={{ alignSelf: 'center', width: '1.5rem' }}>
										<CartIcon />
									</FlexColumn>
								</MoreDetails>
							</CustomerDetailsContainer>
						</FlexRow>
					</FlexColumn>
				</FlexRow>
			</RootContainer>
		);
	}
}
const mapStateToProps = (state) => {
	let orderDetails = state.orders.order_details || {};
	return {
		orderSummary: orderDetails.orderSummary || {},
		orderLines: orderDetails.orderLines || [],
		userDetails: orderDetails.userDetails || {},
	};
};

const mapDispatchToProps = () => {
	return {
		getOrderDetails,
		updateOrderLines,
	};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps())(OrderDetails));
